import { defineComponent as _defineComponent } from 'vue';
import { onMounted } from "vue";
import { refreshContentsWrapper } from "@/utils/data";
import Webhooks from "@/utils/webhooks";
import GridInvocation from "@/components/Grid/GridInvocation.vue";
import WorkflowInvocationState from "@/components/WorkflowInvocationState/WorkflowInvocationState.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowRunSuccess',
    props: {
        workflowName: null,
        invocations: null
    },
    setup(__props) {
        const props = __props;
        onMounted(() => {
            new Webhooks.WebhookView({
                type: "workflow",
                toolId: null,
                toolVersion: null,
            });
            refreshContentsWrapper();
        });
        const targetHistories = props.invocations.reduce((histories, invocation) => {
            if (invocation.history_id && !histories.includes(invocation.history_id)) {
                histories.push(invocation.history_id);
            }
            return histories;
        }, []);
        return { __sfc: true, props, targetHistories, GridInvocation, WorkflowInvocationState };
    }
});
